import script from "./DrawerRight.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerRight.vue?vue&type=script&setup=true&lang=js"

import "./DrawerRight.vue?vue&type=style&index=0&id=e7a3b8b4&lang=scss"

const __exports__ = script;

export default __exports__